import React from "react";
import { Link } from "react-router-dom";

function BrowsingCard({ item }) {
  return (
    <Link
      to={item.sellerUID ?`/sell/${item.id}` : `/rent/${item.id}`}
      className="block max-w-sm rounded-2xl shadow-xl overflow-hidden bg-white hover:shadow-2xl transition"
    >
      {/* Carousel */}
      <div id={`carousel-${item.id}`} className="relative w-full h-56" data-carousel="slide">
        {/* Slides */}
        <div className="relative h-full">

          {item.imageURL_List ?
            item.imageURL_List.map((img, index) => (
              <div
                key={index}
                className={`${index === 0 ? "" : "hidden"} duration-700 ease-in-out`}
                data-carousel-item
              >
                <img
                  src={img}
                  alt={`Slide ${index + 1}`}
                  className="absolute block w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                />
                {/* Gradient Overlay */}
                <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/70 to-transparent"></div>
              </div>
            )) : <div
              key="1"
              className={`duration-700 ease-in-out`}
              data-carousel-item
            >
              <img
                src={item.imageURL}
                alt={`Slide ${1}`}
                className="absolute block w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
              />
              {/* Gradient Overlay */}
              <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/70 to-transparent"></div>
            </div>}
        </div>

        {/* Controls */}
        {/* <button
          type="button"
          className="absolute top-0 start-0 z-2 flex items-center justify-center h-full px-2 cursor-pointer group"
          data-carousel-prev
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/80 group-hover:bg-white shadow">
            <svg className="w-4 h-4 text-black" viewBox="0 0 6 10" fill="none">
              <path d="M5 1L1 5L5 9" stroke="currentColor" strokeWidth="2" />
            </svg>
          </span>
        </button>
        <button
          type="button"
          className="absolute top-0 end-0 z-2 flex items-center justify-center h-full px-2 cursor-pointer group"
          data-carousel-next
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/80 group-hover:bg-white shadow">
            <svg className="w-4 h-4 text-black" viewBox="0 0 6 10" fill="none">
              <path d="M1 1L5 5L1 9" stroke="currentColor" strokeWidth="2" />
            </svg>
          </span>
        </button> */}
      </div>

      {/* Content */}
      <div className="bg-white p-5">
        <h5 className="mb-2 text-l font-bold tracking-tight text-gray-900">{item.title}</h5>
        <p className="mb-3 text-sm text-gray-700">
          {item.description.length > 100
            ? item.description.substring(0, 100) + "..."
            : item.description}
        </p>
        <p className="mb-3 text-lg font-semibold text-blue-700">
          {item.sellerUID ? item.isFree ? "Free" : `$${Number.isInteger(item.price) ? item.price : item.price.toFixed(2)}`
          : item.rentalDaily ? `$${Number.isInteger(item.rentalDaily) ? item.rentalDaily : item.rentalDaily.toFixed(2)} / Day` : "Free"}
        </p>
      </div>

      <hr className="my-2 opacity-30" />

      {/* Footer */}
      <div className="flex items-center gap-3 px-5 pb-4 bg-white">
        {item.employerUser.photo_url ? <img
          src={item.employerUser.photo_url}
          alt="User profile"
          className="w-8 h-8 rounded-full"
        /> : null}
        <div>
          <p className="text-sm font-medium text-gray-900">{item.employerUser.handleName}</p>
          <p className="text-xs text-gray-400">{item.CreatedTime ? item.CreatedTime.toDate().toLocaleString() : item.timePosted.toDate().toLocaleString()}</p>
        </div>
      </div>
    </Link>
  );
}

export default BrowsingCard;